import {assert} from 'Asserts';
import {Cell} from 'notebook/tables/constants/CellConstants';
import {EvaluatedCell, EvaluatedCellError} from 'notebook/tables/excess/Evaluator';

import {addError} from '../excess/Util';

export function getErrorOrWarningFromCell(
  cell: Cell,
  evaluatedCell: EvaluatedCell
): EvaluatedCellError | undefined {
  return addError(cell.error, evaluatedCell.error) ?? undefined;
}

export function getErrorsAndWarningsFromRow(
  cells: Array<Cell>,
  evaluatedCells: Array<EvaluatedCell>
): Array<EvaluatedCellError> {
  assert(cells.length === evaluatedCells.length, 'Number of cells and evaluated cells must be equal');
  const cellErrors = [];
  for (let i = 0; i < cells.length; i++) {
    const maybeError = getErrorOrWarningFromCell(cells[i], evaluatedCells[i]);
    if (maybeError) {
      if (Array.isArray(maybeError)) {
        cellErrors.push(...maybeError);
      } else {
        cellErrors.push(maybeError);
      }
    }
  }
  return cellErrors;
}
